import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Confirm } from "../../components/confirm";
import { deleteMaintenancePlanGroup } from "../../services/maintenance-plan-group";
import { useLocale } from "../../stores/locale";
import { navigateBack } from "../../utils/navigate-back";

export function MaintenancePlanGroupDelete() {
  const navigate = useNavigate();
  const { get: getLocale } = useLocale();
  const queryClient = useQueryClient();
  const { id } = useParams();

  if (!id) {
    throw new Error("Maintenance plan group ID is required");
  }

  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const closeModal = () => {
    navigateBack(navigate, "/admin/maintenance/groups");
  };

  return (
    <Confirm
      header={
        hasError
          ? getLocale("maintenance.groupDeleteError")
          : getLocale("maintenance.confirmDeleteGroup")
      }
      loading={loading}
      onClose={closeModal}
      onConfirm={() => {
        void (async () => {
          setLoading(true);
          try {
            await deleteMaintenancePlanGroup(id);
            await queryClient.invalidateQueries({
              queryKey: ["maintenancePlanGroups"],
            });
            closeModal();
          } catch {
            setHasError(true);
          } finally {
            setLoading(false);
          }
        })();
      }}
    />
  );
}
